<script setup lang="ts">
  import { useMainPageRoute } from '@/composables/useMainPageRoute.composable';
  import { useI18 } from '@/plugins';

  const { t } = useI18();
  const homePage = useMainPageRoute;
</script>

<template>
  <v-container>
    <v-card
      class="mx-auto pa-5"
      width="100%"
      max-width="600px"
      prepend-icon="mdi-lock-alert"
    >
      <v-card-title>
        {{ t('shared.notAuthorizedTitle') }}
      </v-card-title>

      <v-card-text>
        {{ t('shared.notAuthorizedText') }}
      </v-card-text>

      <v-card-actions class="px-4">
        <v-custom-btn color="primary" text :to="{ name: homePage.name }">
          {{ t('shared.home') }}
        </v-custom-btn>
      </v-card-actions>
    </v-card>
  </v-container>
</template>
